// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3BFf-","label":"SetPasswdForm_label__21Udj"};